import { render, staticRenderFns } from "./UploadForms.vue?vue&type=template&id=13e57e11&scoped=true&"
import script from "./UploadForms.vue?vue&type=script&lang=js&"
export * from "./UploadForms.vue?vue&type=script&lang=js&"
import style0 from "./UploadForms.vue?vue&type=style&index=0&id=13e57e11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e57e11",
  null
  
)

export default component.exports